import { put, takeLatest, getContext } from "redux-saga/effects";

import { eventChannel } from "redux-saga";

import { onSnapshot } from "firebase/firestore";

export const apiInitState = {
  loading: false,
  success: true,
  error: false,
  type: null,
};

export function reducerApiConstructor() {
  return {
    // api control
    requestStart: (state, action) => {
      state.api.loading = true;
      state.api.error = false;
      state.api.success = true;
      state.api.type = action.type;
    },

    requestSuccess: (state) => {
      state.api.loading = false;
      state.api.error = false;
      state.api.success = true;
      state.api.type = null;
    },

    requestFail: (state, action) => {
      state.api.loading = false;
      state.api.error = action?.payload?.error || true;
      state.api.success = false;
      state.api.type = action.type;
    },
  };
}

export function sagaApiListenerConstructor(slice) {
  // __API__
  function* requestSuccessSaga(action) {
    if (action?.payload?.redirect) {
      const router = yield getContext("router");
      router.navigate(action?.payload?.redirect);
    }
  }

  function* requestFailSaga(action) {
    if (action?.payload?.message) {
      yield put({
        type: "ui/openAlert",
        payload: { message: action?.payload?.message, severity: "error" },
      });
    }
  }

  return [
    takeLatest(`${slice}/requestSuccess`, requestSuccessSaga),
    takeLatest(`${slice}/requestFail`, requestFailSaga),
  ];
}

export function sagaApiActionsConstructor(slice) {
  function* requestStart() {
    return yield put({
      type: `${slice}/requestStart`,
    });
  }

  function* requestSuccess(redirect) {
    return yield put({
      type: `${slice}/requestSuccess`,
      payload: {
        redirect: redirect || null,
      },
    });
  }

  function* requestError(message) {
    return yield put({
      type: `${slice}/requestFail`,
      payload: {
        message: message || null,
      },
    });
  }

  return { requestStart, requestSuccess, requestError };
}

export function createFirestoreDocumentChannel(docRef) {
  return eventChannel((emit) => {
    const unsubscribe = onSnapshot(
      docRef,
      (doc) => {
        if (doc.exists()) {
          emit({ data: doc.data() });
        } else {
          emit({ error: "No such document!" });
        }
      },
      (error) => {
        emit({ error: error.message });
      }
    );

    // The subscriber must return an unsubscribe function
    return () => unsubscribe();
  });
}

export function createFirestoreDocumentArrayChannel(refArray) {
  return eventChannel((emit) => {
    const unsubscribeArr = refArray.map((ref) => {
      return onSnapshot(ref, (doc) => {
        if (doc.exists) {
          emit({ data: { ...doc.data(), id: ref.id } });
        } else {
          emit({ error: "No such document!" });
        }
      });
    });

    return () => unsubscribeArr.forEach((unsub) => unsub.unsubscribe());
  });
}

export function createFirestoreCollectionChannel(colRef) {
  return eventChannel((emit) => {
    const unsubscribe = onSnapshot(
      colRef,
      (snapshot) => {
        if (snapshot.docs.length === 0) {
          emit({ error: [] });
        } else {
          emit({ data: snapshot.docs.map((doc) => doc.data()) });
        }
      },
      (error) => {
        console.error("Error fetching collection: ", error);
      }
    );

    return () => unsubscribe();
  });
}
